import { useContext } from 'react';
import PageContextProvider from '../context/page-context-provider';

const Translate = (string, translate) => {
  const context = useContext(PageContextProvider);
  if (translate && context) {
    return typeof context.pageContext.staticTranslations[string] !== 'undefined'
      ? context.pageContext.staticTranslations[string]
      : string;
  }
  return string;
};

const TranslateUnconnected = (string, staticTranslations) => {
  return typeof staticTranslations[string] !== 'undefined'
    ? staticTranslations[string]
    : string;
};

export default Translate;
export { TranslateUnconnected };
